var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#1D1D1D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1781 22.9997V13.5536H9.1769V22.9997H12.1784H12.1781ZM10.6781 12.2641C11.7244 12.2641 12.3759 11.5387 12.3759 10.6322C12.3563 9.70511 11.7244 9 10.698 9C9.67085 9 9 9.70511 9 10.6322C9 11.5386 9.65118 12.264 10.6584 12.264H10.6779L10.6781 12.2641ZM13.8392 22.9997H16.8401V17.7251C16.8401 17.4432 16.8597 17.1605 16.939 16.9591C17.1559 16.3948 17.6497 15.8107 18.4789 15.8107C19.5646 15.8107 19.9992 16.6768 19.9992 17.9468V22.9997H23V17.5836C23 14.6822 21.5196 13.3321 19.5452 13.3321C17.9264 13.3321 17.2154 14.2787 16.8204 14.9234H16.8404V13.5539H13.8394C13.8786 14.44 13.8392 23 13.8392 23L13.8392 22.9997Z",
    fill: "#1D1D1D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linked-in.7d0ee6932a0abdf560776571053c6b98.svg";
export { ForwardRef as ReactComponent };